import { ApiService } from "../../../utils/api-service";
import { autoinject } from "aurelia-framework";
import { IText, translate } from "../../../utils/translator";
import { json } from "aurelia-fetch-client";

export interface IMeasureVM {
	id: string;
	name: IText;
	unit: IText;
	specifier: IText;
	code: string;
	allowDecimals: boolean;
	minValue: number;
	maxValue: number;
	description: IText;
	aggregationRuleName: string;
}

export class MeasureVM {
	id: string;
	name: IText;
	unit: IText;
	specifier: IText;
	code: string;
	allowDecimals: boolean;
	minValue: number;
	maxValue: number;
	description: IText;
	aggregationRuleName: string;

	get nameWithSpecifier(): string {
		let value = translate(this.name);
		let translatedSpecifier = translate(this.specifier);
		if(translatedSpecifier && translatedSpecifier.length) {
			value = `${value} (${translatedSpecifier})`;
		}
		return value;
	}

	constructor(init?: Partial<MeasureVM>) {
		Object.assign(this, init);
		this.name = Object.assign({}, this.name);
		this.specifier = Object.assign({}, this.specifier);
		this.unit = Object.assign({}, this.unit);
		this.description = Object.assign({}, this.description);
	}
}

@autoinject
export class MeasuresAdminService {
	constructor(private api: ApiService) {}

	async getMeasures(): Promise<any> {
		return await this.api.fetchJson(`admin/measures`);
	}

	async getMeasure(id: string): Promise<any> {
		return await this.api.fetchJson(`admin/measures/${id}`);
	}

	async updateMeasure(measure: IMeasureVM): Promise<Response> {
		return await this.api.fetch(`admin/measures/${measure.id}`, {
			method: 'put',
			body: json(measure)
		});
	}

	async createMeasure(measure: IMeasureVM): Promise<Response> {
		return await this.api.fetch(`admin/measures/new`, {
			method: 'post',
			body: json(measure)
		});
	}

	async deleteMeasure(measure: IMeasureVM): Promise<Response> {
		return await this.api.fetch(`admin/measures/${measure.id}`, {
			method: 'delete',
			body: json(measure)
		});
	}
}
